import React, { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Button } from "../../../components/ui/Button";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";

interface SubscriptionSuccessProps {
    onClose: () => void;
    planName: string;
    planFeatures?: string[];
    themeColor?: "blue" | "orange" | "purple";
}

const SubscriptionSuccess: React.FC<SubscriptionSuccessProps> = ({
    onClose,
    planName,
    planFeatures,
    themeColor = "blue",
}) => {
    const navigate = usePartnerAwareNavigate();
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const timer = setTimeout(() => handleContinue(), 5000);
        const countdownInterval = setInterval(() => {
            setCountdown((prev) => Math.max(0, prev - 1));
        }, 1000);

        return () => {
            clearTimeout(timer);
            clearInterval(countdownInterval);
        };
    }, []);

    const handleContinue = () => {
        onClose();
        navigate("/");
    };

    const getThemeColor = () => {
        switch (themeColor) {
            case "orange":
                return "bg-orange-500 hover:bg-orange-600";
            case "purple":
                return "bg-purple-500 hover:bg-purple-600";
            default:
                return "bg-blue-500 hover:bg-blue-600";
        }
    };

    return (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-[9999] flex items-center justify-center">
            <div className="w-full max-w-lg mx-4 bg-white rounded-xl shadow-2xl p-6 transform animate-in slide-in-from-bottom-4">
                <div className="w-48 h-48 mx-auto mb-4">
                    <DotLottieReact
                        src="https://lottie.host/cd10b060-5d7e-498d-95ff-35005ab7d8cf/UTbfzd7Z3C.lottie"
                        loop
                        autoplay
                    />
                </div>

                <h2 className="text-2xl font-bold mb-2 text-center text-gray-800">
                    Welcome to {planName}!
                </h2>

                <p className="text-gray-600 text-center mb-4">
                    Your subscription has been activated successfully.
                </p>

                <Button
                    onClick={handleContinue}
                    className={`w-full py-3 text-lg font-medium ${getThemeColor()} text-white transition-all duration-300 rounded-lg`}>
                    Continue to Dashboard {countdown > 0 && `(${countdown})`}
                </Button>
            </div>
        </div>
    );
};

export default SubscriptionSuccess;
